import { Navigate } from 'react-router-dom';

import usePageTitle from '../../hooks/usePageTitle';
import ManageBookForm from './ManageBookForm';
import { useAuth } from '../../AuthContext';
import { CONTAINER_CONTENT_CLASS } from '../signatures/Signatures';

export function CreateBook() {

    usePageTitle('Create Book');

    const {
        viewingAllAccounts
    } = useAuth();

    if (viewingAllAccounts) {
        // We can only create a service when viewing a single account
        return <Navigate to="/" />;
    }


    return <>
        <div className="container-fixed">
            <div className={CONTAINER_CONTENT_CLASS}>
                <div className="flex flex-col justify-center gap-2">
                    <h1 className="text-xl font-semibold leading-none text-gray-900">
                        Create Book
                    </h1>
                    <div className="flex items-center gap-2 text-sm font-medium text-gray-600">
                        {/* subtitle? */}
                    </div>
                </div>
                {false && <div className="flex items-center gap-2.5">
                    <a className="btn btn-sm btn-light" href="#">
                        Go to Teams
                    </a>
                </div>}
            </div>
        </div>
        <div className="container-fixed">
            <ManageBookForm />
        </div>
    </>
}